import React from 'react';
import EditNonPayableBenefitsForm from './EditNonPayableBenefitsForm';

const EditNonPayableBenefitsView = () => {
  return <EditNonPayableBenefitsForm />;
};

export default EditNonPayableBenefitsView;
